import React, { memo, useCallback, useState } from "react";
import useDialogManager from "@/utils/useDialogManager";
import UserDropList from "@/components/Topbar/userDropList";
import ButtonUI from "@/componentsUI/Button";
import { useNavigate } from "react-router";
import { useGlobalState } from "@/store/commonStore";
import { useTranslationPlus } from "@/Core/i18n/useTranslationPlus";
import LogoUI from "@/components/LogoUI";
import DropdownWallet from "@/components/WalletComp/DropdownWallet";
import PageMaxContainer from "../pageMaxContainer/PageMaxContainer";
import InstallTopBanner from "@/features/install/installTopBanner/InstallTopBanner";
import bonusGift from "@/assets/image/bonus-gift.png";
import {
  isHomeWidgetRedDotVisible,
  markHomeWidgetRedDotSeen,
} from "@/features/common/homeWidget/redDot";
import styles from "./style/topbar.module.less";

const BONUS_CENTER_RED_DOT_KEY = "bonusCenter";

function Topbar() {
  const navigate = useNavigate();
  const { t } = useTranslationPlus("HomeView");
  const { t: tO } = useTranslationPlus();
  const { isLogin } = useGlobalState();
  const { openSignUp, openSignIn } = useDialogManager();

  const [hasBonusRedDot, setHasBonusRedDot] = useState(() =>
    isHomeWidgetRedDotVisible(BONUS_CENTER_RED_DOT_KEY)
  );
  const handleBonusRedDotSeen = useCallback(() => {
    markHomeWidgetRedDotSeen(BONUS_CENTER_RED_DOT_KEY);
    setHasBonusRedDot(false);
  }, []);

  function signUp() {
    openSignUp();
  }

  function toHome() {
    navigate("/home");
  }

  return (
    <div className={styles.topbar}>
      <InstallTopBanner />
      <PageMaxContainer className={styles.headerWrapperContainer}>
        <div className={styles.headerWrapper}>
          <div className={styles.topbarContent}>
            <button
              type="button"
              className={styles.topbarLogoButton}
              onClick={toHome}
              aria-label={t("Home")}
            >
              <LogoUI />
            </button>

            {isLogin && (
              <div className={styles.walletItem}>
                <DropdownWallet />
              </div>
            )}
            {!isLogin && (
              <div className={styles.authActions}>
                <ButtonUI
                  type="default"
                  buttonColor="secondary"
                  loading={false}
                  loadingFixedWidth={false}
                  className={styles.loginBtn}
                  onClick={() => openSignIn()}
                >
                  {tO("Signin.Login")}
                </ButtonUI>
                <ButtonUI
                  type="primary"
                  loading={false}
                  loadingFixedWidth={false}
                  className={styles.loginBtn}
                  onClick={signUp}
                >
                  {tO("Signup.Signup")}
                </ButtonUI>
              </div>
            )}
            {isLogin && (
              <button
                type="button"
                className={styles.bonusButton}
                data-red-dot={hasBonusRedDot ? "true" : undefined}
                onClick={() => {
                  handleBonusRedDotSeen();
                  navigate("/bonus");
                }}
                aria-label={t("Bonus")}
                title={t("Bonus")}
              >
                <img src={bonusGift} alt="" draggable={false} />
              </button>
            )}
            {isLogin && (
              <div className={styles.avatarItem}>
                <UserDropList
                  hasBonusRedDot={hasBonusRedDot}
                  onBonusRedDotSeen={handleBonusRedDotSeen}
                />
              </div>
            )}
          </div>
        </div>
      </PageMaxContainer>
    </div>
  );
}

export default memo(Topbar);
